<template>
  <div>
    <div class="form-group">
      <Typeahead
        v-model="counterParty"
        label="Who is the Counterparty? (Business name)"
        :items="allAvailableCounterParties"
        :errors="$page.props.errors.counter_party_id"
        placeholder="Start typing to search..."
        :tolerance="0"
        return-field="id"
        id-field="id"
        search-field="name"
        display-field="name"
        @selected="counterPartySelected"
        @noResults="showAddNewCounterParty"
        @listAppend="showAddNewCounterParty"
        show-list-append
      >
        <template v-slot:item="slotProps">
          <span v-if="slotProps.match.name">{{ slotProps.match.name }}<br /></span>
          <strong v-if="slotProps.match.address"><small>Address: {{ slotProps.match.address }}</small></strong>
          <strong v-if="slotProps.match.registered_number"><small>Phone: {{ slotProps.match.registered_number }}</small></strong>
        </template>
        <template v-slot:noResults>
          <small>We couldn't find a match.</small><br />
          <span class="text-primary">Add a new Counterparty</span>
        </template>
        <template v-slot:listAppend>
          <small>Can't find the correct Counterparty?</small><br />
          <span class="text-primary">Add a new Counterparty</span>
        </template>
      </Typeahead>
    </div>

    <div v-if="showAdd" class="card mb-4">
      <div class="card-body">
        <form @submit.prevent="addCounterparty">
          <div class="form-group">
            <TextInput
              v-model="newCounterparty.name"
              :errors="errors ? errors.name : []"
              type="text"
              autofocus
              autocapitalize="off"
              label="Who is the Counterparty? (Business name)"
              @input="errors.name = []"
              validateSuccess
              validateError
            />
          </div>

          <div class="form-group">
            <TextInput
              v-model="newCounterparty.registered_number"
              :errors="errors ? errors.registered_number : []"
              type="text"
              autofocus
              autocapitalize="off"
              label="Registered Number"
              @input="errors.registered_number = []"
              validateSuccess
              validateError
            />
          </div>

          <div class="form-group">
            <TextArea
              label="Address"
              v-model="newCounterparty.address"
              :errors="errors ? errors.address : []"
              autofocus
              autocapitalize="off"
              rows="4"
              @input="errors.address = []"
              validateSuccess
              validateError
            />
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-md-3 flex">
                <LoadingButton
                  :loading="adding"
                  class="btn btn-primary btn-block"
                  type="submit"
                  >Create</LoadingButton
                >
                <button
                  class="btn btn-secondary btn-block"
                  @click.prevent="showAdd = false"
                >Cancel</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],

  data() {
    return {
      form: {
        role: 'supplier',
        counter_party_id: this.asset ? this.asset.counter_party_id : null,
        counter_party_type: this.asset ? this.asset.counter_party_type : null,
      },
      newCounterparty: {
        name: '',
        address: '',
        registered_number: '',
      },
      choiceItems: [
        {
          label: 'Selling goods and/or services (Supplier)',
          value: 'supplier',
        }, {
          label: 'Buying goods and/or services (Customer)',
          value: 'customer',
        },
      ],
      valid: false,
      adding: false,
      showAdd: false,
      errors: {
        name: [],
        address: [],
        registered_number: [],
      },
    };
  },

  methods: {
    showAddNewCounterParty(query) {
      this.showAdd = true;
      this.newCounterparty.name = query;
    },

    counterPartySelected(cp) {
      this.$page.props.errors.counter_party_id = null;

      if (cp) {
        this.form.counter_party_id = cp.id;
        this.form.counter_party_type = cp.type;
        this.showAdd = false;
      } else {
        this.form.counter_party_id = null;
        this.form.counter_party_type = null;
      }
    },

    addCounterparty() {
      this.adding = true;
      window.axios
        .post('/counter-party', this.newCounterparty)
        .then(({ data }) => {
          this.adding = false;
          this.showAdd = false;
          this.newCounterparty.name = '';
          this.newCounterparty.registered_number = '';
          this.newCounterparty.address = '';
          this.counterPartiesData.push(data);
          this.counterParty = data;
          this.form.counter_party_id = data.id;
          this.form.counter_party_type = 'App\\Models\\CounterParty';
        })
        .catch((error) => {
          this.adding = false;
          this.errors = error.response.data.errors;
          throw new Error(error);
        });
    },
  },
};
</script>
